module.exports = __webpack_public_path__ + "img/diy-WzXnYuMyIi.a08b05fe.svg";